import React from 'react';
import NavMenu from '../Nav/NavMenu';
import Footer from '../footer/Footer';
import EmptySlider from '../sliders/EmptySlider'
import DownloadAppSection from '../global/DownloadAppSection';
import emptySliderIcon from "../../assets/static/support.png";
import { Container, Row, Col, Button } from 'react-bootstrap';
import MoneyskillImage from "../../assets/static/helpcenter/dailt_savings_Account.png";


function Career() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br><br></br>
    <EmptySlider 
        title="Build Your Future with Kontriman" 
        description="Explore exciting career opportunities at Kontriman. Whether you need guidance, support, or answers, our help center, chat support, and email are here for you. Start your journey with us today!" 
        imageUrl={emptySliderIcon} 
    />
       <div>
      <Container fluid className="my-5 bg-custom">
        <Container className='container-padding'>
          <Row className="flex-column flex-md-row">
            {/* Image column */}
            <Col md={6} className="order-2 order-md-1">
              <img
                src={MoneyskillImage}
                alt="Careers at Kontriman"
                className="img-fluid"
              />
            </Col>

            {/* Text column */}
            <Col md={6} className="d-flex align-items-center order-1 order-md-2">
              <div>
                <h1 className='custom_heading'>Build Your Career with Kontriman</h1>
                <p>
                  At Kontriman Cooperative Credit Union, we’re not just building financial solutions — we’re building a team of passionate, purpose-driven professionals who believe in community, integrity, and innovation. Join us and grow your career while making a meaningful impact.
                </p>

                <h5 className='mt-4'>Why Work with Us?</h5>
                <ul>
                  <li>Inclusive and values-based work culture</li>
                  <li>Opportunities for growth and learning</li>
                  <li>Impact-driven work that touches real lives</li>
                  <li>Competitive compensation and staff benefits</li>
                </ul>

                <h5 className='mt-4'>We’re Hiring!</h5>
                <ul>
                  <li>Daily Cash Collectors</li>
                  <li>Java Developers</li>
                  <li>Python Developers</li>
                  <li>Full Stack Developer</li>
                  <li>React/Angular/Flutter Developer</li>
                </ul>

                <a href="mailto:enquiries@kontriman.com">
                  <Button className='custom-button mt-3'>Apply Now</Button>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
    <Footer></Footer>
    </div>
  );
}

export default Career;
